var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar__container"},[_c('div',{staticClass:"progress-bar-recorded",class:_vm.colorClass,style:(_vm.fillWidth)}),(!_vm.alwaysShowFull || _vm.max === 0)?_c('div',{staticClass:"progress-bar-forecasted",class:_vm.max !== 0 && _vm.value > _vm.max ? _vm.colorClass : {},style:(_vm.backgroundWidth)}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }